<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Gestion des publications numériques">
          <div class="flex md12">
            <div class="row row-inside">
              <div class="flex md12">
                <div class="row row-inside">
                  <div
                    class="flex md2"
                    v-for="element in yearList"
                  >
                    <va-button
                      class="fullwidth"
                      :color="element === activeYear ? 'success' : 'info'"
                      @click="activeYear = element"
                    >{{ element }}</va-button>
                  </div>
                </div>
              </div>
              <div class="flex md12">
                <div class="row row-inside">
                  <div
                    class="flex md2 container ma-2"
                    v-for="element in activeNumbers"
                    :style="backgroundColor(element)"
                    @click="openNumero(element)"
                  >
                    <div class="numero-box">
                      {{
							moment(
							  element.annee + "-" + element.mois,
							  "YYYY-MM"
							).format("MMMM YYYY")
						  }}
                    </div>
                    <div class="date-box">
                      <p>{{
                        element.produit_previsionnel_final?"Prévisionnel: "+element.produit_previsionnel_final:null
					  }}</p>
                      <p>
                        {{
                        element.produit_effectif?"Effectif: "+element.produit_effectif:null
                      }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="flex md3 offset--md9"
                v-if="this.$store.getters.user.publications_numeros"
              >
                <va-button
                  color="info"
                  @click="createNew()"
                >
                  <va-icon
                    size="15px"
                    name="fa fa-plus"
                  />
                  <span>&nbsp Nouvelle année</span></va-button>
              </div>
            </div>
          </div>
        </va-card>
      </div>
    </div>
    <create-publication
      v-model="showCreatePublication"
      @creation="updateList"
    />
  </div>
</template>

<script>
import axios from "axios";
import CreatePublication from "./numeroCreation";
import { sortedUniq, sortBy } from "lodash";
import moment from "moment";

export default {
  name: "publications-list",
  components: { CreatePublication },
  data() {
    return {
      showCreatePublication: false,
      publicationsList: [],
      activeYear: moment().year(),
      //export within context
      moment: moment,
    };
  },
  created() {
    this.updateList();
  },
  computed: {
    activeNumbers() {
      let tmpList = this.publicationsList.filter((element) => {
        if (
          element.annee === this.activeYear
        ) {
          return true;
        }

        return false;
      });

      return tmpList;
    },

    yearList() {
      let tmpList = [];
      this.publicationsList.forEach((element) => {
        tmpList.push(element.annee);
      });

      tmpList = sortedUniq(sortBy(tmpList));

      if (!this.activeYear) {
        this.activeYear = tmpList[0];
      }

      return tmpList;
    },
  },
  methods: {
    openNumero(element) {
      this.$router.push({
        name: "annonces-web",
        params: { idnumero: element.idpublication },
      });
    },
    backgroundColor(element) {
      let now = moment();

      let dateElement = moment(element.annee + '-' + element.mois, "YYYY-MM");
      if (dateElement.isBefore(now.format("YYYY-MM"))) {
        return { backgroundColor: "#ccc" };
      } else if (dateElement.format("YYYY-MM") === now.format("YYYY-MM")) {
        return { backgroundColor: "#4ae387" };
      } else {
        return { backgroundColor: "#4ab2e3" };
      }
    },
    async updateList() {
      try {
        let temp = await axios.get("/api/publications-web/list");
        this.publicationsList = temp.data;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors de la récupération de la liste des publications"
        );
      }
    },
    createNew() {
      if (this.idnumero) {
        return;
      }
      this.showCreatePublication = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 95%;
}

.container {
  text-align: center;
  min-height: 6em;
}

.container:hover {
  cursor: pointer;
}

.numero-box {
  color: white;
  font-size: 1.5em;
  font-weight: bold;
}

.hors-series-text {
  color: white;
  font-size: 1em;
  font-weight: bold;
}

.date-box {
  color: white;
}
</style>
